module.exports = __webpack_public_path__ + "static/img/3.5ee59d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/3.png
// module id = nsst
// module chunks = 0